import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  DriverTripCalculatorFormData,
  TripCalculation,
  LocationPairRoute,
} from "_interfaces/driverTripCalculator.interfaces";

export interface SegmentRoute {
  totalDistance: number;
  totalTime: number;
  pairs: LocationPairRoute[];
}

export interface DtcState {
  currentStep: 1 | 2 | 3;
  formData: DriverTripCalculatorFormData | null;
  calculationResult: TripCalculation | null;
  segmentRoutes: Record<number, SegmentRoute>;
}

const initialState: DtcState = {
  currentStep: 1,
  formData: null,
  calculationResult: null,
  segmentRoutes: {},
};

const driverTripCalculatorSlice = createSlice({
  name: "driverTripCalculator",
  initialState,
  reducers: {
    setCurrentStep(state, { payload }: PayloadAction<1 | 2 | 3>) {
      state.currentStep = payload;
    },
    saveFormData(state, { payload }: PayloadAction<DriverTripCalculatorFormData>) {
      state.formData = payload;
    },
    setCalculationResult(state, { payload }: PayloadAction<TripCalculation | null>) {
      state.calculationResult = payload;
    },
    setSegmentRoutes(state, { payload }: PayloadAction<Record<number, SegmentRoute>>) {
      state.segmentRoutes = payload;
    },
    resetDtcState() {
      return initialState;
    },
  },
});

export const {
  setCurrentStep,
  saveFormData,
  setCalculationResult,
  setSegmentRoutes,
  resetDtcState,
} = driverTripCalculatorSlice.actions;

export default driverTripCalculatorSlice.reducer;
